import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconDisplayPort24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="display port">
            <path
                d="M7 10C6.44772 10 6 10.4477 6 11V13H8V12H18V13H20V11C20 10.4477 19.5523 10 19 10H7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 6C0.447715 6 0 6.44772 0 7V14C0 14.4089 0.248951 14.7766 0.628609 14.9285L5.62861 16.9285C5.74673 16.9757 5.87278 17 6 17H23C23.5523 17 24 16.5523 24 16V7C24 6.44772 23.5523 6 23 6H1ZM2 13.323V8H22V15H6.19258L2 13.323Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
